import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import modals from './components/Modals/reducer';
import notification from './components/Notification/reducer';

export default (history: History) => ({
  modals,
  notification,
  router: connectRouter(history),
});
